var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "form",
      {
        directives: [
          {
            name: "disable-all",
            rawName: "v-disable-all",
            value: !_vm.loaded,
            expression: "!loaded"
          }
        ],
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.submit.apply(null, arguments)
          }
        }
      },
      [
        _vm.saved
          ? _c(
              "div",
              { staticClass: "row message", attrs: { "aria-live": "polite" } },
              [_vm._v("Your account has been updated!")]
            )
          : _vm._e(),
        _c("div", { staticClass: "row two-cols" }, [
          _c(
            "div",
            { class: _vm.v$.first_name.$error ? "has_error" : "" },
            [
              _c("label", { attrs: { for: "user_first_name" } }, [
                _vm._v("First Name (Required)")
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.first_name,
                    expression: "first_name"
                  }
                ],
                attrs: {
                  type: "text",
                  name: "first_name",
                  "aria-describedby": "user_first_name"
                },
                domProps: { value: _vm.first_name },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.first_name = $event.target.value
                  }
                }
              }),
              _vm._l(_vm.v$.first_name.$errors, function(error) {
                return _c("p", {
                  key: error.$uid,
                  staticClass: "error",
                  attrs: { id: "user_first_name", role: "status" },
                  domProps: { innerHTML: _vm._s(error.$message) }
                })
              })
            ],
            2
          ),
          _c(
            "div",
            { class: _vm.v$.last_name.$error ? "has_error" : "" },
            [
              _c("label", { attrs: { for: "user_last_name" } }, [
                _vm._v("Last Name (Required)")
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.last_name,
                    expression: "last_name"
                  }
                ],
                attrs: {
                  type: "text",
                  name: "last_name",
                  id: "user_last_name"
                },
                domProps: { value: _vm.last_name },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.last_name = $event.target.value
                  }
                }
              }),
              _vm._l(_vm.v$.last_name.$errors, function(error) {
                return _c("p", {
                  key: error.$uid,
                  staticClass: "error",
                  attrs: {
                    "aria-describedby": "user_last_name",
                    role: "status"
                  },
                  domProps: { innerHTML: _vm._s(error.$message) }
                })
              })
            ],
            2
          )
        ]),
        _c(
          "div",
          { staticClass: "row", class: _vm.v$.email.$error ? "has_error" : "" },
          [
            _c("label", { attrs: { for: "user_email" } }, [_vm._v("Email")]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.email,
                  expression: "email"
                }
              ],
              attrs: {
                type: "email",
                name: "email",
                "aria-describedby": "user_email",
                readonly: ""
              },
              domProps: { value: _vm.email },
              on: {
                change: _vm.v$.email.$touch,
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.email = $event.target.value
                }
              }
            }),
            _vm._l(_vm.v$.email.$errors, function(error) {
              return _c("p", {
                key: error.$uid,
                staticClass: "error",
                attrs: { id: "user_email", role: "status" },
                domProps: { innerHTML: _vm._s(error.$message) }
              })
            })
          ],
          2
        ),
        _c(
          "div",
          {
            staticClass: "row",
            class: _vm.v$.postal_code.$error ? "has_error" : ""
          },
          [
            _c("label", { attrs: { for: "user_postal_code" } }, [
              _vm._v("Zip Code")
            ]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.postal_code,
                  expression: "postal_code"
                }
              ],
              attrs: {
                type: "text",
                name: "postal_code",
                "aria-describedby": "user_postal_code"
              },
              domProps: { value: _vm.postal_code },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.postal_code = $event.target.value
                }
              }
            }),
            _vm._l(_vm.v$.postal_code.$errors, function(error) {
              return _c("p", {
                key: error.$uid,
                staticClass: "error",
                attrs: { id: "user_postal_code", role: "status" },
                domProps: { innerHTML: _vm._s(error.$message) }
              })
            })
          ],
          2
        ),
        _vm._m(0),
        _c(
          "div",
          {
            staticClass: "row",
            class: _vm.v$.old_password.$error ? "has_error" : ""
          },
          [
            _c("label", { attrs: { for: "user_old_password" } }, [
              _vm._v("Current Password (Required)")
            ]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.old_password,
                  expression: "old_password"
                }
              ],
              attrs: {
                type: "password",
                "aria-describedby": "user_old_password",
                name: "old_password"
              },
              domProps: { value: _vm.old_password },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.old_password = $event.target.value
                }
              }
            }),
            _vm._l(_vm.v$.old_password.$errors, function(error) {
              return _c("p", {
                key: error.$uid,
                staticClass: "error",
                attrs: { id: "user_old_password", role: "status" },
                domProps: { innerHTML: _vm._s(error.$message) }
              })
            })
          ],
          2
        ),
        _c(
          "div",
          {
            staticClass: "row",
            class: _vm.v$.password.$error ? "has_error" : ""
          },
          [
            _c("label", { attrs: { for: "user_password" } }, [
              _vm._v("New Password (Optional)")
            ]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.password,
                  expression: "password"
                }
              ],
              attrs: {
                type: "password",
                "aria-describedby": "user_password",
                name: "password"
              },
              domProps: { value: _vm.password },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.password = $event.target.value
                }
              }
            }),
            _vm._l(_vm.v$.password.$errors, function(error) {
              return _c("p", {
                key: error.$uid,
                staticClass: "error",
                attrs: { id: "user_password", role: "status" },
                domProps: { innerHTML: _vm._s(error.$message) }
              })
            })
          ],
          2
        ),
        _c(
          "div",
          {
            staticClass: "row",
            class: _vm.v$.password_confirmation.$error ? "has_error" : ""
          },
          [
            _c("label", { attrs: { for: "user_password_confirmation" } }, [
              _vm._v("Confirm Password (Optional)")
            ]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.password_confirmation,
                  expression: "password_confirmation"
                }
              ],
              attrs: {
                type: "password",
                "aria-describedby": "user_password_confirmation",
                name: "password_confirmation"
              },
              domProps: { value: _vm.password_confirmation },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.password_confirmation = $event.target.value
                }
              }
            }),
            _vm._l(_vm.v$.password_confirmation.$errors, function(error) {
              return _c("p", {
                key: error.$uid,
                staticClass: "error",
                attrs: { id: "user_password_confirmation", role: "status" },
                domProps: { innerHTML: _vm._s(error.$message) }
              })
            })
          ],
          2
        ),
        _vm._m(1)
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("label", { attrs: { for: "user_question1" } }, [
        _vm._v("What's your dietary preference?")
      ]),
      _c(
        "select",
        {
          attrs: {
            name: "question1",
            id: "user_question1",
            "data-question": "DietPreference",
            "data-question-id": "8270a1d0-46c1-4b88-a360-bffbafd337da"
          }
        },
        [
          _c("option", { attrs: { disabled: "", selected: "" } }, [
            _vm._v("Select Answer")
          ]),
          _c("option", { attrs: { value: "Searching for KETO Snacks" } }, [
            _vm._v("Searching for KETO Snacks")
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "Low Carb/Low Sugar Solutions" } }, [
            _vm._v("Low Carb/Low Sugar Solutions")
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "Protein Seeker" } }, [
            _vm._v("Protein Seeker")
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("input", {
        staticClass: "btn btn--primary",
        attrs: { type: "submit", value: "Submit" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }